import { number2Px } from "../../../lib/utils/styling";
export function isIntersect(x1, x2, x3, x4) {
  // 判断两个线段是否有重叠部分
  return !(Math.max(x1, x2) < Math.min(x3, x4) || Math.max(x3, x4) < Math.min(x1, x2));
}
export function getIntersectionRect(rect1, rect2) {
  // 计算相交矩形的左边界、上边界、右边界和下边界
  const left = Math.max(rect1.left, rect2.left);
  const top = Math.max(rect1.top, rect2.top);
  const right = Math.min(rect1.right, rect2.right);
  const bottom = Math.min(rect1.bottom, rect2.bottom);
  // 判断是否有相交区域
  if (left < right && top < bottom) {
    // 返回相交矩形的 boundingClientRect 对象
    return {
      left,
      top,
      right,
      bottom,
      width: right - left,
      height: bottom - top
    };
  }
  return null; // 没有相交区域
}
export function getInspectLineStyle(boundaryA, boundaryB, direction, pos, style = {}) {
  return number2Px({
    '--line-length': Math.abs(boundaryA - boundaryB),
    '--line-pos-vertex': Math.min(boundaryA, boundaryB),
    '--line-pos-vertical': pos,
    '--line-border-style': style.borderStyle || 'solid'
  });
}
export function getLineLength(boundaryA, boundaryB) {
  return Math.abs(boundaryA - boundaryB);
}
export function round(px) {
  return Math.round(px * 2) / 2;
}
export function lineCrossRect(line, direction, rect) {
  if (direction === 'h') {
    return line >= rect.top && line <= rect.bottom;
  }
  return line >= rect.left && line <= rect.right;
}
export function rectMiddleX(rect) {
  return (rect.left + rect.right) / 2;
}
export function rectMiddleY(rect) {
  return (rect.top + rect.bottom) / 2;
}
//# sourceMappingURL=utils.js.map
